import { ContentMetaDataItem } from '../EventTrackingTypes';

/**
 * Extract and flatten content metadata categories into an object
 * where keys are category names and values are comma-separated item names.
 *
 * Example input: [{category: 'Topic', name: 'Marketing'}, {category: 'Topic', name: 'Sales'}]
 * Example output: {Topic: 'Marketing, Sales'}
 */
export const extractCategories = (items: ContentMetaDataItem[]): {
  [key: string]: string
} => items.reduce((acc, item) => {
  // If the category is not already in the accumulator, initialize it with an empty string
  if (!acc[item.category]) {
    acc[item.category] = '';
  }
  // Concatenate the name to the category, adding a comma if necessary
  const newValue = acc[item.category] ? `${acc[item.category]}, ${item.name}` : item.name;
  acc[item.category] = newValue.trim();
  return acc;
}, {} as { [key: string]: string });
